import Stack from '@mui/material/Stack';
import { getCreditLineByProduct } from 'lib/api/creditLine';
import TableCard from 'lib/designSystem/Card/TableCard';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import SubtitleWithTooltip from 'lib/designSystem/SubtitleWithTooltip';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { showAlert } from 'lib/functions/utils';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

import CreditLineStatus from '../Common/CreditLineStatus';
import Warranties from './components/Warranties';
import WarrantyForm from './components/WarrantyForm';

const CreditLine = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const businessIdentifier = auth.user?.businessIdentifier;
  const { data, isPending } = getCreditLineByProduct(
    dispatch,
    businessIdentifier,
    'sgr',
  );
  const showWarrantyForm = data?.status === 'ACTIVE' && !isPending;
  const successFn = () => {
    showAlert(dispatch, 'success', 'Garantía cotizada correctamente');
  };
  return (
    <Stack direction="column" gap={2} mb={4}>
      <CreditLineStatus productId="sgr" />

      {showWarrantyForm && (
        <TableCard>
          <SubtitleWithTooltip
            title="Cotizar garantía"
            tooltipContent="Desde aca puedes cotizar una garantía para tu empresa."
          />
          <WarrantyForm direction="row" successFn={successFn} />
        </TableCard>
      )}
    </Stack>
  );
};

const SGR = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const businessIdentifier = auth.user?.businessIdentifier;
  const { data, isPending } = getCreditLineByProduct(
    dispatch,
    businessIdentifier,
    'sgr',
  );

  if (isPending) return <CenteredCircularProgress />;

  const getAvailableTabs = () => {
    const tabs = [
      {
        label: 'Línea de Garantías',
        component: <CreditLine />,
        index: 0,
      },
    ];

    if (data) {
      tabs.push({
        label: 'Garantías',
        component: <Warranties />,
        index: 1,
      });
    }

    return tabs;
  };

  const tabs = getAvailableTabs();

  return (
    <Stack direction="column" gap={2}>
      <EnhancedTab title="Garantías" startValue={0} tabs={tabs} />
    </Stack>
  );
};

export default SGR;
